import React from 'react';

export default class EditorErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Keep the browser console evidence without exposing technical details in the editor UI.
    console.error('VR editor render error', error, info);
    window.__VR_SAVE_DRAFT__?.().catch(() => undefined);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <main className="editor-recovery-screen" role="alert">
        <section className="editor-recovery-card">
          <h1>编辑器遇到异常</h1>
          <p>重新打开后会尝试恢复最近已保存的本机草稿。</p>
          <button type="button" onClick={() => window.location.reload()}>
            重新打开并恢复草稿
          </button>
        </section>
      </main>
    );
  }
}
